const PRICE_FORMATER = new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
})

/**
 * formatPrice
 * @param {number} price price
 * @returns {string} Result
 */
export default function formatPrice(price) {
    return PRICE_FORMATER.format(price)
}
